import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from "../../environments/environment";
import { ApiService } from '../services/api.service';
import { routerAnimation } from '../animations/router.animation';
import { SharedService } from '../services/shared.service';
import { LocalStorageService } from '../services/localstorage.service';
import { KeyContents } from '../services/keycontents.service';
import { Communities } from '../services/communities.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [ApiService, Communities],
  animations: [ routerAnimation ],
})
export class LayoutComponent implements OnInit {
	public user: any = {};
  public fullscreen : boolean = false;
  public contentIsLoaded: boolean = false;
  public communitiesIsLoaded: boolean = false;
  public userIsLoaded: boolean = false;
  public zeebraUrl = environment.zeebraUrl;
  public active_community: any = {};

  constructor(
  	private _router: Router,
    private _route: ActivatedRoute,
  	private _storage: LocalStorageService,
    private _api: ApiService,
    private _sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private _content: KeyContents,
    private _communities: Communities
  ) { }

  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  goBack() {
    if (this._route.snapshot.queryParams.from) {
      window.location.href = this._route.snapshot.queryParams.from
    } else {
      window.history.back()
    }
  }

  logout():void {
  	this._storage.delete('token');
    this._storage.delete('user');
    this._storage.delete('community_id');
    this.user = {};
    window.location.href = environment.zeebraUrl;
  }

  setUser():void {
    this.getContents()
    if(this._storage.getObject('user')) {
      this.user = this._storage.getObject('user');
      if (
        this._route.snapshot.queryParamMap.get('community_id')
      ) {
        this._storage.set('community_id', this._route.snapshot.queryParamMap.get('community_id'));
      }
      if (!this._storage.get('community_id')) {
        this._storage.set('community_id', this.user.communities[0].id);
      }

      this.user.initials = this.user.first_name.charAt(0) + this.user.last_name.charAt(0);

      this.getPermissions()
      this.userIsLoaded = true
      
      this.getCommunities()
    }
  }

  private getPermissions() {
    this._api.permissions
      .retrieve(this._storage.get('community_id') + '/permissions')
      .subscribe(
        (data) => {
          this.user = Object.assign(this.user, data);
          this._storage.setObject('user', this.user);
        },
        (err) => { console.log(err) });
  }

  private getContents() {
    console.log('get contents')
    this._api.keycontents
    .list()
    .subscribe(
      (data) => {
        this._content.setContents(data);
        this.contentIsLoaded = true
      },
      (err) => { console.log(err) });
  }

  private getCommunities() {
    this._api.communities.list({limit: 100}).subscribe(
      (data) => {
        this._communities.setCommunities(data.results);
        this.communitiesIsLoaded = true
        this.active_community = this._communities.getCurrentCommunity(this._storage.get('community_id'));
      },
      (err) => { console.log(err) });
  }

  ngOnInit(){
    console.log('layout init')
    this.setUser();
    this._sharedService.changeEmitted$
      .subscribe(data => {
         if (data.user) {
           this.setUser();
         }
      });
  }
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/layout/layout.component.ts